const { validateUUID, validateCardID } = require("../validator");
const { validateCardSchema } = require("../validator/validate-schema");
const { AxiosAdapter } = require("../http/http-adapter");
const { Mapper } = require("../schema/mapper-adapter");
const mundipaggMap = require("../schema/card.map").mundipagg;

class MundipaggCard {
  constructor({ personId, baseUrl, gatewayUrl, accessToken, token }) {
    this.token = token;
    this.accessToken = accessToken
    this.baseUrl = baseUrl;
    this.gatewayUrl = gatewayUrl;
    this.personId = personId;
    this.request = new AxiosAdapter(this.baseUrl);
    this.request.setAuthHeader(this.accessToken);
  }

  list() {
    return new Promise((resolve, reject) => {
      if (!validateUUID(this.personId)) {
        throw new Error("PersonId is invalid");
      }
      this.request
          .get(`/customers/${this.personId}/card`)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          });
    });
  };

  async create(card) {
    const isValid = validateCardSchema(card);
    if (isValid instanceof Error) throw new Error(isValid)
    const cardMap = Mapper(card, mundipaggMap);
    const request = new AxiosAdapter(this.gatewayUrl);
    const resp = await request.post(`/tokens?appId=${this.token}`, {
      type: "card",
      card: cardMap
    });

    if (resp.status === 200) {
      const payload = { token: resp.data.id };
      if (cardMap.billing_address) {
        payload["billing_address"] = cardMap.billing_address;
      }
      return this.request.post(`/customers/${this.personId}/card/`, payload);
    }

    throw new Error("Card data is invalid");
  };

  async createCardToken(card) {
    const isValid = validateCardSchema(card);
    if (isValid instanceof Error) throw new Error(isValid)
    const cardMap = Mapper(card, mundipaggMap);
    const request = new AxiosAdapter(this.gatewayUrl);
    const resp = await request.post(`/tokens?appId=${this.token}`, {
      type: "card",
      card: cardMap
    });

    return resp;
  };

  remove (cardId)  {
    if (!validateCardID(cardId)) throw new Error("CardId is invalid");
    return this.request.remove(`/customers/${this.personId}/card/${cardId}`);
  };
}

module.exports = {
  MundipaggCard,
};